export const ACTION = {

    INVESTOR_FORM_LIST:'INVESTOR_FORM_LIST',
    NOTICES_AGENDA_LIST: 'NOTICES_AGENDA_LIST',
    ADD_INFO_LIST: 'ADD_INFO_LIST',
    FUND_LITERATURE_LIST: 'FUND_LITERATURE_LIST',
    INVESTOR_LANDING_PAGE: 'INVESTOR_LANDING_PAGE',
    INVESTOR_GENERAL_FAQ: 'INVESTOR_GENERAL_FAQ',
    INVESTOR_MARKET: 'INVESTOR_MARKET',
    FUND_LITERATURE_DATA: 'FUND_LITERATURE_DATA',
    FACTSHEET: 'FACTSHEET',
    FACTSHEET_MONTH: 'FACTSHEET_MONTH',
    ADDITIONAL_FUND_INFO: 'ADDITIONAL_FUND_INFO',
    FUND_DOCUMENT_FILTER_LIST: 'FUND_DOCUMENT_FILTER_LIST',
    OUR_ONLINE_SERVICES: 'OUR_ONLINE_SERVICES',
    AGENDA_MONTH: 'AGENDA_MONTH',
    GET_SCHEME_ACCOUNT_FILTER: 'GET_SCHEME_ACCOUNT_FILTER',
    GET_SCHEME_ACCOUNT_CONTENT: 'GET_SCHEME_ACCOUNT_CONTENT',
    CLEAR_FUND_LITERATURE_LIST: 'CLEAR_FUND_LITERATURE_LIST',
    GET_MARKET_VIDEO_DETAILS: 'GET_MARKET_VIDEO_DETAILS',
    GET_PORTFOLIO_DATA: 'GET_PORTFOLIO_DATA',
};


